import {
  isIPassengerIneligibleAdditional,
  type BookingCellId,
  type IApprovalBookingConflict,
  type IApprovalSetBookingConflictAPI,
  type IReasonDto,
} from "@ryde/shared";

export const getApprovalBookingConflictAPI = (
  approvalBookingConflicts: Map<BookingCellId, IApprovalBookingConflict[]>,
): IApprovalSetBookingConflictAPI[] => {
  return [...approvalBookingConflicts.values()]
    .flat()
    .filter(({ approvalReason }) => approvalReason !== null)
    .map(
      ({
        id,
        bookingId,
        passengerId,
        displayDirection,
        approver,
        approvalReason,
        date,
        errorAdditional,
      }) => {
        return {
          id,
          bookingId,
          passengerId,
          approver: approver as string,
          approvalReasonId: (approvalReason as IReasonDto)?.id,
          date,
          displayDirection,
          direction: isIPassengerIneligibleAdditional(errorAdditional)
            ? errorAdditional.direction
            : undefined,
        };
      },
    );
};
